import AlertAutoClose from './AlertAutoClose';
export default AlertAutoClose;